function build (Vue) {
    Vue.directive('my-loading', {
        inserted: function (el) {
            el.style.cssText = "color: blue;";
        }
    })
}

export default build